import { render, staticRenderFns } from "./RptPlazos.vue?vue&type=template&id=59dffde4&"
import script from "./RptPlazos.vue?vue&type=script&lang=js&"
export * from "./RptPlazos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports